import React, { Component } from 'react';
import ReactTooltip         from 'react-tooltip';
import { connect }          from 'react-redux';

class Bt_Comentario_Equipe extends Component {
    render() {

        const vetor          = this.props.vetor;
        const tur_pos_id     = this.props.all_posts_equipe[vetor].equ_pos_id;
        const qtd_comentario = this.props.all_posts_equipe[vetor].qtd_comentarios;
         
        return (
                 <button 
                    type              = "button"
                    data-tip data-for = {'comments_'}
                    onClick           = {this.props.funcao}
                    className         = "btn btn-xs btn-link comments">
                    <span className   = "glyphicon glyphicon-comment"></span>
                    <span className   = "countLike" id={`comments_${tur_pos_id}`}>
                        { qtd_comentario === 0 ? null : qtd_comentario }
                    </span>
                    <ReactTooltip id={'comments_'} type='dark' effect='solid'>
                        <span>Comentário</span>
                    </ReactTooltip>
                 </button>
          );
    }
}

function  mapStateToProps(state){

    return { 
             all_posts_equipe : state.equipeReducer.all_equipe_posts
           }
}

export default connect(mapStateToProps)(Bt_Comentario_Equipe);




// WEBPACK FOOTER //
// ./src/container/bt_comentario_timeline_equipe.js